import {
    FETCH_FLOW24_SERVER_CONFIG,
} from "./actionTypes";
import axios from "axios";
import { FLOW24_SERVER_CONFIG_URL } from "../../config"

/**
 * Pobieranie konfiguracji servera flow24
 * 
 */
export const fetchFlow24ServerConfig = () => {
    return dispatch => {
        return axios
            .get(FLOW24_SERVER_CONFIG_URL)
            .then(response => {
                dispatch(fetchFlow24ServerConfigSuccess(response.data));
            })
    }
}

/**
 * Akcja pomyślnego pobrania konfiguracji 
 * 
 * @param {object} data Obiekt pobranej konfiguracji
 */
const fetchFlow24ServerConfigSuccess = data => {
    return {
        type: FETCH_FLOW24_SERVER_CONFIG,
        payload: data
    };
};